<template>
    <!-- 教练卡片 -->
    <div class="ptm pbm bob">
      <router-link :to="{name:'coachitem',params: { coachId: coachInfo.coachId}}" class="clear mtn coach-card">
        <div class="left coach-card__avatar">
            <avatar-box v-if="coachInfo.avatar" :avatar="coachInfo.avatar" :auth="coachInfo.user.isVip" style="width:100%;height:100%;"></avatar-box>
            <avatar-box v-else-if="coachInfo.avatar==''" :avatar="coachInfo.user.largeAvatar" :auth="coachInfo.user.isVip" style="width:100%;height:100%;"></avatar-box>
            <avatar-box v-else :avatar="null" style="width:100%;height:100%;"></avatar-box>  <!-- 解决显示图标 -->
        </div>
        <div class="coach-card__info">
          <div class="coach-card__info--uname bob pbm">
            <div class="fs3 c4">{{ coachInfo.realName }} 
                <div class="coach-card__info--price red fs1"><strong class="fs3">{{coachInfo.price?coachInfo.price:0}}</strong>/课时起</div></div>
            <div class="fs1 c9 mtn clear">
                <van-rate class="left fs1" v-model="rateNum" :size="13" disabled-color="#FF6F0F" disabled />&nbsp;
                <span>/ 累计上课{{ coachInfo.lessons?coachInfo.lessons:0 }}课时</span>
            </div>
            <div class="c6 coach-card__info--about fs1" :title="coachInfo.desc">
                {{coachInfo.desc}}
            </div>
          </div>
          <div class="coach-card__info--auth fs2 c9 mtm">
            <van-tag v-if="coachInfo.isCertification == 1" plain>新锐台球认证</van-tag>
            <van-tag v-if="coachInfo.qualificationCnt!=''" plain>{{coachInfo.qualificationCnt}}项专业认证</van-tag>
            <van-tag v-if="coachInfo && coachInfo.title" plain>{{coachInfo.title | titleFilter}}</van-tag>
          </div>
        </div>
      </router-link>
    </div>
</template>
<script>
import Vue from 'vue';
import { Rate } from 'vant';
import AvatarBox from '@/components/AvatarBox';
Vue.use(Rate);
export default {
    name: 'CoachCardNew',
    components:{
        AvatarBox
    },
    filters: {
        titleFilter(status) {
        // 教练职称
        const statusMap = {
            assistant: '助教',
            junior: '初级教练',
            intermediate: '中级教练',
            senior: '高级教练'
        }
        return statusMap[status]
        }
    },
    props:{
        coachInfo:{  //教练信息
            type: Object,
            required: true
        },
    },
    data(){
        return {

        }
    },
    computed:{
        rateNum(){
            if(this.coachInfo.rating == '' || this.coachInfo.rating==0){
                return 5
            }else{
                return this.coachInfo.rating
            }
        }
    }
}
</script>
<style lang="less" scoped>
// 教练信息模块
.coach-card {
    position: relative;
    display: block;
    &__avatar {
        width: 0.5rem;
        height: 0.5rem;
        margin-right: 0.1rem;
        // overflow: hidden;
    }
    &__info {
        float: left;
        width:calc(100%-0.6rem);
        &--auth {
            & > .iconfont {
                font-size: 0.14rem;
                color: #FFA800;
            }
        }
        &--about{
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-top: .05rem;
        }
        &--price{
            position: absolute;
            right: 0;
            top: 0;
        }
        &--price:before {
        content: '¥';
        font-size: 0.12rem;
        margin-right: 0.02rem;
    }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CoachCardNew.vue